import styled from '@emotion/styled';
import { ButtonWithIcon as Button } from 'src/components/ButtonWithIcon/ButtonWithIcon';


export const RejectFormWrapper = styled('div', { label: 'RejectFormWrapper' })`
    display: flex;
`;

export const SelectWrapper = styled('div', { label: 'SelectWrapper' })`
    position: relative;
    flex: 1 1 auto;
`;

export const ButtonWrapper = styled(Button, { label: 'ButtonWrapper' })`
    font-size: 16px;
    margin-left: 8px;
`;
